export default __webpack_public_path__ + "static/media/iconeTipoInformacao.9ea13d85.svg";